import React from 'react';
import { Router, Route, browserHistory, Redirect } from "react-router";
import ReactDOM from 'react-dom';
import App from './App';
import Login from "./Login";
import Layout from "./Layout";
import Reports from "./Reports";
import EndPoint from "./rest";
import swal from "sweetalert2";
import AuthStore from "./stores/AuthStore";
import './index.css';

const securityEnforcer = (nextState, replace,next)=>{
	if (localStorage.getItem("token")) {
		EndPoint.API.get("/me")
		.then((response)=>{
			AuthStore.setUser(response.data.user);
			AuthStore.setDate(response.data.date);
			next();
		})
		.catch((error)=>{
			if (error.response && error.response.status) {
				EndPoint.API.get("/refresh")
				.then((response) => {
					EndPoint.setToken(response.headers.authorization);
				})
				.catch(()=> {
					swal({
						title: 'Introduzca sus credenciales',
						type: 'info'
					});
					replace('/login');
				})
				.then(()=>{
					next();
				});
			}
		})
	} else {
		replace('/login');
		next();
	}
};

ReactDOM.render(
  <Router history={browserHistory}>
	  <Redirect from="/" to="/calendar"/>
	  <Route path="/login" component={Login}/>
	  <Route path="/" component={Layout} onEnter={securityEnforcer}>
		  <Route path="/calendar" component={App}/>
		  <Route path="/reports" component={Reports}/>
	  </Route>
	  <Redirect from="*" to="/calendar"/>
  </Router>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/